/**
 * The service types every shop starts with (Phase 1 spec, "Service types: data").
 *
 * `key` is the stable identity — a slug, frozen at creation. `label` is what the shop sees
 * and may rename. The array order is the list order: each default gets its index as its
 * `sort_order`.
 *
 * ⚠️ MIGRATION 0034 HOLDS A SECOND COPY. It seeded every shop that existed when it ran, SQL
 * cannot import this file, and a migration is FROZEN once it has run. So the two do not stay
 * in step by themselves: `packages/db/test/service-types.test.ts` pins both to one literal
 * snapshot, and fails while they disagree. The day this list changes on purpose, the test's
 * expectation for NEW shops changes with it; its snapshot of 0034 stays as it is.
 */

/** "Service plan" is found by its KEY, never its label: a shop may rename the label. */
export const SERVICE_PLAN_KEY = 'service_plan';

export interface DefaultServiceType {
  key: string;
  label: string;
}

export const DEFAULT_SERVICE_TYPES: readonly DefaultServiceType[] = [
  { key: 'repair', label: 'Repair' },
  { key: 'maintenance', label: 'Maintenance' },
  { key: 'installation', label: 'Installation' },
  { key: 'diagnostic', label: 'Diagnostic' },
  { key: SERVICE_PLAN_KEY, label: 'Service plan' },
];
